"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGroceryItemMutationOptions = exports.updateGroceryItemMutation = void 0;
const client_1 = require("@apollo/client");
const recipePreviewFragment_1 = require("../../recipe/fragments/recipePreviewFragment");
exports.updateGroceryItemMutation = client_1.gql `
  mutation UpdateGroceryItem(
    $id: String!
    $input: UpdateGroceryItemInput!
    $rememberOptions: RememberOptions
  ) {
    updateGroceryItem(
      id: $id
      input: $input
      rememberOptions: $rememberOptions
    ) {
      __typename
      item {
        __typename
        id
        complete
        amount
        unit
        name
        keyword
        groceryCategoryName
      }
      recipe {
        id
        ingredients {
          ... on RegularIngredient {
            ...AllRegularIngredients
          }
          ... on IngredientHeader {
            ...AllIngredientHeader
          }
          ... on RecipeLink {
            ...AllRecipeLink
          }
        }
      }
    }
  }

  ${recipePreviewFragment_1.AllRegularIngredientFragment}
  ${recipePreviewFragment_1.AllIngredientHeaderFragment}
  ${recipePreviewFragment_1.AllRecipeLinkFragment}
`;
exports.updateGroceryItemMutationOptions = (variables) => ({
    variables,
});
//# sourceMappingURL=UpdateGroceryItem.js.map